import React, { useEffect, useRef, useState } from "react";
import { Modal, Checkbox, FormControlLabel } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import zoomout from "../../assets/images/zoomOut.svg"
import zoomIn from "../../assets/images/zoomIn.svg"
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import "./Policy.css";
import { useTranslationContext } from "../../contexts/TranslationContext";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./Policy.css";

// Configure pdfjs worker for version 4.x
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

const Policy = ({
  handleOnclickSubmit,
  open,
  onClose,
  pdfFile,
  heading,
  isPolicyFirst,
}) => {
  const [checked, setChecked] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [zoom, setZoom] = useState(1.0); // default zoom
  const modalRef = useRef(null);
  const { translations } = useTranslationContext();
  const loadingPdf = translations["loading_pdf"] || "Loading PDF...";
  const loadingPdfError = translations["loading_pdf_error"] || "Failed to load PDF";
  const zoomOutText = translations["zoom_out_text"] || "Zoom Out";
  const zoomInText = translations["zoom_in_text"] || "Zoom In";

  useEffect(() => {
    if (open) {
      setZoom(1.0); // Reset zoom to default on modal open
    }
  }, [open]);

  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, onClose]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="policy-modal-overlay">
        <div className="policy-modal-content" ref={modalRef}>
          <div className="policy-modal-header">
            <div className="heading-title">{heading}</div>
            <div className="zoom-buttons">
              <button onClick={handleZoomOut} className="zoom-btn" type="button" title={zoomOutText}><img src={zoomout} alt="zoom-out"></img></button>
              <button onClick={handleZoomIn} className="zoom-btn" type="button" title={zoomInText}><img src={zoomIn} alt="zoom-in"></img></button>
            </div>
          </div>

          <div className="pdf-scrollable-wrapper">
            <div className="pdf-viewer-container">
              {pdfFile ? (
                <Document
                  file={pdfFile}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={<p>{loadingPdf}</p>}
                  error={<p>{loadingPdfError}</p>}
                >
                  {Array.from(new Array(numPages), (_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      scale={zoom}
                      width={Math.min(window.innerWidth - 40, 650)}
                    />
                  ))}
                </Document>
              ) : (
                <p>No PDF to display</p>
              )}
            </div>
          </div>

          <div className="policy-footer">
            {isPolicyFirst && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                    style={{ color: "#FD8238" }}
                  />
                }
                label="I have read and agree to the policy"
                sx={{ color: "#000000" }}
              />
            )}
            <div className="button-container">
              <button
                disabled={isPolicyFirst && !checked}
                onClick={handleOnclickSubmit}
                className="submit-policy-btn"
                style={{
                  backgroundColor:
                    isPolicyFirst && !checked ? "#F2B79E" : "#FD8238",
                  color: "#fff",
                }}
              >
                {isPolicyFirst ? "Accept & Continue" : "Close"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Policy;
